/* --- FILE: src\components\SearchFormGroup\SearchFormGroup.js --- */
import React from 'react';
import { Form, Button, Row, Col, Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faFilter } from '@fortawesome/free-solid-svg-icons';
import './SearchFormGroup.css';

export const SearchFormGroup = ({ 
    quicksearch, setQuickSearch, getQuickSearch, 
    buttontext2, message2, errormessage2, successmessage2,
    
    sermondate, setSermonDate, 
    topic, setTopic, getsermontitle,
    preacher, setPreacher, getsermonpreacher,
    buttontext, getDeepSearch, 
    message, errormessage, successmessage
}) => {
    return (
        <Container className="search-group-container">
            <Row className="g-4">
                
                {/* --- CARD 1: QUICK SEARCH --- */}
                <Col lg={4} md={12}>
                    <div className="search-card">
                        <h6 className="search-title"><FontAwesomeIcon icon={faSearch} /> Quick Find</h6>
                        
                        {/* Status Messages for Quick Search */}
                        {message2 === 'success' && <div className="alert alert-success p-2 small mb-2">{successmessage2}</div>}
                        {message2 === 'error' && <div className="alert alert-danger p-2 small mb-2">{errormessage2}</div>}

                        <Form.Group className="mb-3">
                            <Form.Control
                                type="text"
                                placeholder="Enter keywords..."
                                className="modern-input"
                                value={quicksearch}
                                onChange={(event) => setQuickSearch(event.target.value)}
                            />
                        </Form.Group>
                        
                        <Button 
                            className="w-100 search-btn-pill" 
                            onClick={getQuickSearch}
                            disabled={buttontext2 === "Processing"}
                        >
                            {buttontext2}
                        </Button>
                    </div>
                </Col>

                {/* --- CARD 2: FILTER LIBRARY --- */}
                <Col lg={8} md={12}>
                    <div className="search-card">
                        <h6 className="search-title"><FontAwesomeIcon icon={faFilter} /> Filter Library</h6>
                        
                        {/* Status Messages for Deep Search */}
                        {message === 'success' && <div className="alert alert-success p-2 small mb-2">{successmessage}</div>}
                        {message === 'error' && <div className="alert alert-danger p-2 small mb-2">{errormessage}</div>}

                        <Form>
                            <Row className="g-3">
                                {/* Date Input */}
                                <Col md={4} sm={12}>
                                    <Form.Control 
                                        type="date" 
                                        className="modern-input"
                                        value={sermondate} 
                                        onChange={(event) => setSermonDate(event.target.value)} 
                                    />
                                </Col>

                                {/* Topic Dropdown (Restored Logic) */}
                                <Col md={4} sm={12}>
                                    <Form.Select 
                                        className="modern-input" 
                                        value={topic} 
                                        onChange={(event) => setTopic(event.target.value)}
                                    >
                                        <option>Topic</option>
                                        {getsermontitle && getsermontitle.length > 0 && getsermontitle.map((getSermonTitleData, index) => (
                                            <option key={index} value={getSermonTitleData.sermons_title}>
                                                {getSermonTitleData.sermons_title}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Col>

                                {/* Preacher Dropdown (Restored Logic) */}
                                <Col md={4} sm={12}>
                                    <Form.Select 
                                        className="modern-input" 
                                        value={preacher} 
                                        onChange={(event) => setPreacher(event.target.value)}
                                    >
                                        <option>Preacher</option>
                                        {getsermonpreacher && getsermonpreacher.length > 0 && getsermonpreacher.map((getSermonPreacherData, index) => (
                                            <option key={index} value={getSermonPreacherData.sermons_title}>
                                                {getSermonPreacherData.sermons_preacher}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Col>
                            </Row>

                            <div className="mt-4 text-end">
                                <Button 
                                    className="search-btn-pill px-5" 
                                    onClick={getDeepSearch}
                                    disabled={buttontext === "Processing"}
                                >
                                    {buttontext}
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};